export default __webpack_public_path__ + "static/media/EPFL1.65c6a3a0.png";